export default __webpack_public_path__ + "static/media/objects-thinking-introversion.5dc122e1.png";